import React, { useState } from 'react';

import { FormControl, FormHelperText } from '../Form';
import { Slider } from '../Slider';
import { styled } from '../styled';

const StyledSlider = styled(Slider, {
  shouldForwardProp: (p) => p !== 'untouched',
})(({ theme, untouched }) => ({
  ...(untouched ? {
    '& .MuiSlider-thumb': {
      opacity: 0,
    },
    '& .MuiSlider-markLabel': {
      color: theme.palette.action.active,
    },
  } : {}),
}));

export default function SliderField({
  input: {
    name,
    value,
    type,
    onChange,
    ...restInput
  },
  meta: { touched, error },
  required,
  options,
  fullWidth,
  helperText,
  formatterText = 'Please choose a score',
  ...custom
}) {
  const convertValue = () => {
    if (value === '') return custom.defaultValue || 0;
    if (typeof value === 'string') return parseInt(value, 10);
    return value;
  };

  const [controlValue, setControlValue] = useState(convertValue());

  const hasError = Boolean(touched && error);

  const optionValueFormatter = (v) => (
    value !== ''
      ? options.find((o) => o.value === v).label
      : formatterText
  );

  const handleChange = (e, v) => {
    onChange(v);
  };

  const handleSlideChange = (e, v) => {
    if (v !== controlValue) setControlValue(v);
  };

  return (
    <FormControl
      required={required}
      variant={custom.variant}
      style={{ width: (fullWidth ? '100%' : undefined) }}
    >
      <FormHelperText style={{ textAlign: 'center' }}>{optionValueFormatter(controlValue)}</FormHelperText>
      <StyledSlider
        error={hasError ? error : helperText}
        name={name}
        defaultValue={convertValue()}
        onChangeCommitted={handleChange}
        onChange={handleSlideChange}
        untouched={value === ''}
        {...(options ? {
          max: options.length - 1,
        } : {})}
        {...custom}
      />
      {(helperText || hasError) && (
        <FormHelperText error={hasError}>{hasError ? error : helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
